import TooltipMui, { TooltipProps } from '@mui/material/Tooltip';
import styled from 'styled-components';

type StyledTooltipProps = TooltipProps & {
  className?: string;
};
const Tooltip = styled(({ className, ...rest }: StyledTooltipProps) => <TooltipMui classes={{ tooltip: className }} {...rest} />)(({ theme }) => {
  return {
    ...theme.typography.body2,
    background: theme.palette.background.blueGrey,
    color: theme.palette.text.primary,
    padding: theme.spacing(2, 4),
    border: `1px solid ${theme.palette.background.blueGrey}`,
    boxShadow: theme.shadows[4],
    '& .MuiTooltip-arrow': {
      '&:before': {
        color: theme.palette.background.blueGrey,
      },
    },
  };
});

export default {
  Tooltip,
};
